import { FC, MouseEvent, useEffect, useRef, useState } from "react";
import "./Index.scoped.scss";
import { data, types } from "../data";
import { Form, Input, Button, Select, message, Pagination } from "antd";
import useIndexStore from "../../store/index.store";
import PickState from "../../store/utils";
import { UserContent } from "../../typing";
const { TextArea } = Input;
const Index: FC = () => {
    const [messageApi, contextHolder] = message.useMessage();
    const {
        fetchSmsCode,
        login,
        userContent,
        submit,
        changeUserContent,
        selTypeInfo,
        setSelTypeInfo,
        lazyList,
        choosenList,
        search,
        loading,
        changePage,
    } = useIndexStore(
        PickState([
            "fetchSmsCode",
            "login",
            "userContent",
            "submit",
            "changeUserContent",
            "selTypeInfo",
            "setSelTypeInfo",
            "lazyList",
            "choosenList",
            "search",
            "loading",
            "changePage",
        ]),
    );

    const hdlChangeType = (obj: any) => (e: MouseEvent) => {
        setSelTypeInfo(obj);
        let target = e.target as HTMLElement;
        if (
            target.classList.contains("logo") ||
            target.classList.contains("name")
        ) {
            target = target.parentElement!;
        }
        let p = target.parentElement;
        let nextSibling = p?.nextSibling;
        let typesEl = document.querySelector(".types")! as HTMLElement;
        let formEl = document.querySelector(".sel-intro") as HTMLElement;
        if (nextSibling) {
            typesEl.insertBefore(formEl, nextSibling);
        } else {
            typesEl.append(formEl);
        }
        formEl.classList.add("active");
    };
    const [showSmsTime, setShowSmsTime] = useState(false);
    const [smsTime, setSmsTime] = useState(60);
    const timerRef = useRef<any>();

    const hdlGetSmsCode = async () => {
        if (showSmsTime) {
            return;
        }
        if (!form.getFieldValue("phone")) {
            messageApi.error("请填写手机号");
            return;
        }
        setSmsTime(60);
        if (!showSmsTime) {
            setShowSmsTime(true);
        }
        clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            // console.log("倒计时");
            setSmsTime((preVal) => {
                if (preVal > 0) {
                    return preVal - 1;
                }
                clearInterval(timerRef.current);
                setShowSmsTime(false);
                return 0;
            });
        }, 1000);
        let res = await fetchSmsCode();
        if (res.data.status_code == 1) {
            messageApi.success("验证码发送成功，请注意查收");
        } else if (res.data.status_code == 0) {
            messageApi.error(res.data.msg);
        }
    };

    // const hdlChangeField = (field: keyof UserContent) => (e: any) => {
    //     let val = e.target.value;
    //     changeUserContent(field, val);
    // };
    const [form] = Form.useForm();
    const onValuesChange = (changedValues: any, allValues: any) => {
        for (let key in changedValues) {
            changeUserContent(key as keyof UserContent, changedValues[key]);
        }
    };
    const onFinish = async (values: any) => {
        if (loading) {
            return;
        }
        let res = await login();
        if (res.data.status_code == 0) {
            messageApi.error(res.data.msg);
        } else if (res.data.status_code == 1) {
            let res1 = await submit();
            form.setFieldsValue(userContent);
            clearInterval(timerRef.current);
            setSmsTime(60);
            setShowSmsTime(false);
            if (res1.data.result == 1) {
                messageApi.success("提交成功");
            } else {
                messageApi.error("提交失败");
            }
        }
    };

    const hdlSearchType = (value: string) => {
        search(value);
    };

    useEffect(() => {
        choosenList();
    }, []);

    const hdlChangePage = (page: number) => {
        changePage(page);
    };

    return (
        <div className="page">
            {contextHolder}
            <img
                className="banner"
                src={require("~@/assets/banner.png")}
                alt=""
            />
            <div className="container">
                <div className="intro-box">
                    <div>
                    中国政府网联合每日经济新闻等媒体，邀你参加“@国务院 我为政府工作报告提建议”建言征集。
                    <br />这条通道直达国务院，你的看法和建议或将转给《政府工作报告》起草组。
                    </div>
                </div>
                <div className="types-box">
                    <div className="title">你想说什么？</div>
                    <div className="tips">
                        点选下列各分类即可对应分类主题建言
                    </div>
                    <div className="types">
                        {data.map((item, i) => {
                            return (
                                <div className={` row row${i}`} key={i}>
                                    {item.map((child: any) => {
                                        return (
                                            <div
                                                className={`item ${
                                                    selTypeInfo?.id == child.id
                                                        ? "active"
                                                        : ""
                                                }`}
                                                key={child.id}
                                                onClick={hdlChangeType(child)}>
                                                <img
                                                    className="logo"
                                                    src={require(`~@/assets/type/${
                                                        child.id
                                                    }${
                                                        selTypeInfo?.id ==
                                                        child.id
                                                            ? "-active"
                                                            : ""
                                                    }.png`)}
                                                    alt=""
                                                />
                                                <div
                                                    className="name"
                                                    dangerouslySetInnerHTML={{
                                                        __html: child.title,
                                                    }}></div>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                    <div className="sel-intro">
                        <div className="intro" dangerouslySetInnerHTML={{
                            __html: selTypeInfo?.desc
                        }}></div>
                    </div>
                </div>

                <Form
                    form={form}
                    className={`form ${
                        selTypeInfo?.id != undefined ? "active" : ""
                    }`}
                    name="basic"
                    autoComplete="off"
                    onFinish={onFinish}
                    onValuesChange={onValuesChange}>
                    <div className="title-box">
                        <div className="title">我想说</div>
                        <div className="title">
                            {selTypeInfo?.title
                                ? selTypeInfo.title.replace("<br/>", "")
                                : ""}
                        </div>
                    </div>
                    <div className="row">
                        <Form.Item
                            label="标题"
                            name="title"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写标题",
                                },
                            ]}>
                            <Input />
                        </Form.Item>
                    </div>
                    <div className="row">
                        <Form.Item
                            label="正文"
                            name="desc"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写正文",
                                },
                            ]}>
                            <TextArea rows={4} />
                        </Form.Item>
                    </div>
                    <div className="row">
                        <Form.Item
                            label="昵称"
                            name="nickname"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写昵称",
                                },
                            ]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="单位" name="company">
                            <Input />
                        </Form.Item>
                        <Form.Item
                            className="fixed"
                            label="手机号"
                            name="phone"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写手机号",
                                },
                            ]}>
                            <Input />
                        </Form.Item>
                    </div>
                    <div className="row smsCode">
                        <Form.Item
                            label="姓名"
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写姓名",
                                },
                            ]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="职务" name="job_title">
                            <Input />
                        </Form.Item>
                        <div className="smsCode-input-box fixed">
                            <Form.Item
                                className="smsCode-input"
                                label="短信验证码"
                                name="smsCode"
                                rules={[
                                    {
                                        required: true,
                                        message: "请填写短信验证码",
                                    },
                                ]}>
                                <Input placeholder="请输入验证码" />
                            </Form.Item>
                            <div
                                className="smsCode-btn"
                                onClick={hdlGetSmsCode}>
                                发送验证码
                                <span
                                    className={`time  ${
                                        showSmsTime ? "active" : ""
                                    } `}>
                                    ({smsTime}s)
                                </span>
                            </div>
                        </div>
                        <div className="tips">
                            未注册手机号验证后自动创建每日经济新闻APP账户
                        </div>
                    </div>
                    <div className="row perc50">
                        <Form.Item
                            label="身份证"
                            name="id_code"
                            rules={[
                                {
                                    required: true,
                                    message: "请填写身份证",
                                },
                            ]}>
                            <Input />
                        </Form.Item>
                    </div>
                    <div className="g-tips">
                        以上除“单位”和“职务”外均为必填项，提供真实姓名、身份证号、手机号等信息，将提高建言的可信度，你的意见会更受重视
                    </div>
                    <div className="row submit-box">
                        <Button
                            className="submit"
                            type="primary"
                            htmlType="submit">
                            <img src={require("~@/assets/submit.png")} alt="" />
                            <span>提交</span>
                        </Button>
                    </div>
                </Form>

                <div className="all-advice">
                    <div className="top">
                        <div className="title">看看网民提了什么建议</div>
                        <Select
                            placeholder="请选择建言类别"
                            style={{ width: 200 }}
                            onChange={hdlSearchType}
                            options={types.map((item) => {
                                return {
                                    label: item.replace("<br/>", ""),
                                    value: item,
                                };
                            })}
                        />
                    </div>
                    {lazyList.list.length > 0 ? (
                        <>
                            <div className="list">
                                {lazyList.list.map((item, i) => {
                                    return (
                                        <div className="item" key={i}>
                                            <div className="left">
                                                <img
                                                    src={require("~@/assets/user.png")}
                                                    alt=""
                                                />
                                            </div>
                                            <div className="right">
                                                <div className="name">
                                                    {item.detail.nickname}
                                                </div>
                                                <div className="content">
                                                    {item.detail.desc}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="pagination-box">
                                <Pagination
                                    current={lazyList.page}
                                    pageSize={lazyList.per}
                                    total={lazyList.all_count}
                                    onChange={hdlChangePage}
                                />
                            </div>
                        </>
                    ) : (
                        <div className="no-content">暂无数据</div>
                    )}
                </div>

                <div className="thanks">
                    <div className="name">
                    感谢你的参与，我们将认真汇总大家的建言！
                    </div>
                    <div className="content">
                    这是中国政府网围绕《政府工作报告》开展的建言征集活动，我们将精选有代表性的建言转给《政府工作报告》起草组，并将相关建言转地方部门研究处理。
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
